// extracted by mini-css-extract-plugin
module.exports = {"notFound_content":"notFound_notFound_content__2eMwk","text":"notFound_text__9h44K","goHome":"notFound_goHome__1bVN3","btn":"notFound_btn__3BfMd"};